import styled from 'styled-components';
import { Button } from 'antd';

export const StyledAddButton = styled(Button)`
  margin-top: ${({ theme }) => theme.spacing.space_2};
  margin-bottom: ${({ theme }) => theme.spacing.space_4};
`;
